import React from 'react';

export default function LevelProgressBar({ level = 3, xp = 65 }) {
  return (
    <div className="bg-black p-4 rounded-lg shadow mb-6">
      <div className="flex justify-between items-center mb-1">
        <h3 className="text-sm font-semibold text-gray-800">🏆 Level {level}</h3>
        <span className="text-xs text-gray-500">{xp}% XP</span>
      </div>
      <div className="w-full bg-gray-200 h-2 rounded">
        <div
          className="h-2 rounded bg-gradient-to-r from-green-400 to-blue-600"
          style={{ width: `${xp}%` }}
        ></div>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        Complete more tasks and earn badges to level up.
      </p>
    </div>
  );
}
